module.exports = __webpack_public_path__ + "static/media/cert2.5abdf33a.png";